/** Formatage de dates de presse — module léger, importable côté client. */
export function formatPressDate(date: string) {
  const [y, m, d] = date.split("-");
  const months = [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
  ];
  return `${Number(d)} ${months[Number(m) - 1]} ${y}`;
}
